import { ACCESS } from '@src/configs/permission'
import lazyLoading from '@src/components/widgets/LazyLoading'

import { TRouteConfig } from '../routeConfig'

const OpsConsole = lazyLoading(() => import('@src/pages/ops-console'))
const BadgeManagement = lazyLoading(() => import('@src/pages/badge-management'))
const MonthlyDiscountConfig = lazyLoading(() => import('@src/pages/monthly-discount-config'))
const AppConfigManagement = lazyLoading(() => import('@src/pages/app-config-management'))
const BannerManagement = lazyLoading(() => import('@src/pages/banner-management'))
const SupportProgramManagement = lazyLoading(() => import('@src/pages/support-program-management'))
const SupportFaqManagement = lazyLoading(() => import('@src/pages/support-faq-management'))
const TravelProgramManagement = lazyLoading(() => import('@src/pages/travel-program-management'))
const ItemCodeGroup = lazyLoading(() => import('@src/pages/item-code-group'))
const ItemCodeGroupDetail = lazyLoading(() => import('@src/pages/item-code-group/detail'))
const AnnualDiscountConfig = lazyLoading(() => import('@src/pages/annual-discount-config'))

const opsRouter: TRouteConfig[] = [
  {
    path: '/ops-console',
    Element: OpsConsole,
    key: ACCESS.GENERAL,
  },
  {
    path: '/badge-management',
    Element: BadgeManagement,
    key: ACCESS.VIEW_BADGE,
  },
  {
    path: '/monthly-discount-config',
    Element: MonthlyDiscountConfig,
    key: ACCESS.VIEW_RATE_CONFIG,
  },
  {
    path: '/app-config',
    Element: AppConfigManagement,
    key: ACCESS.VIEW_APP_CONFIG,
  },
  {
    path: '/banner-management',
    Element: BannerManagement,
    key: ACCESS.VIEW_HOME_CONTENT,
  },
  {
    path: '/support-program-management',
    Element: SupportProgramManagement,
    key: ACCESS.VIEW_HOME_CONTENT,
  },
  {
    path: '/support-faq-management',
    Element: SupportFaqManagement,
    key: ACCESS.VIEW_FAQ_CONTENT,
  },
  {
    path: '/travel-program-management',
    Element: TravelProgramManagement,
    key: ACCESS.VIEW_TRAVEL_PROGRAM_CONTENT,
  },
  {
    path: '/item-code-group',
    Element: ItemCodeGroup,
    key: ACCESS.VIEW_RATE_CONFIG,
  },
  {
    path: '/item-code-group/:id',
    Element: ItemCodeGroupDetail,
    key: ACCESS.VIEW_RATE_CONFIG,
  },
  {
    path: '/annual-discount-config',
    Element: AnnualDiscountConfig,
    key: ACCESS.VIEW_RATE_CONFIG,
  },
]

export { opsRouter }
